export const debounce = (func, delay) => {
    let timerId;
    return (...args) => {
        if (timerId) {
            clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

export const limitChar = (str) => {
    if (str?.length <= 15) {
        return str;
    } else {
        return `${str?.slice(0, 15)}...`
    }
}

export const getCategories = (categories) => {
    const cats = categories?.map(item => item?.name).join(", ")
    return cats
}

const VIDEO_EXTENSIONS = ["m3u8", "mp4", "mov", "m4v", "webm", "avi", "mkv"];

// True when the URL points at a video file (HLS playlist or raw video).
export const isVideoUrl = (url) => {
    if (typeof url !== "string" || !url) return false;
    const ext = url.split("?")[0].split(".").pop()?.toLowerCase();
    return VIDEO_EXTENSIONS.includes(ext);
}

// Best displayable image for a post. Posts store the playable video in
// `media` and a poster frame in `thumbnail`; `media` itself is only usable
// as an <img> when the post is a photo. Returns null when there is nothing
// renderable so callers can fall back to a placeholder.
export const getPostThumbnail = (post) => {
    if (!post || post.type === "TEXT_POST") return null;
    if (post.thumbnail) return post.thumbnail;
    if (post.media && !isVideoUrl(post.media)) return post.media;
    return null;
}

export const handleToast = (msg, toast, toastId, setToastId) => {
    if (toastId) {
        toast.dismiss(toastId);
        setToastId(null);
    }
    const id = toast.error(msg);
    setToastId(id);
}
